import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Common colors.
 * Generate a name from HEX color: http://chir.ag/projects/name-that-color
 * If the name already exists, try to be creative by adding a suffix :)
 */


var grayDarkM = '#41434A';
var primaryM = '#924B54';
var blue = '#4978BC';
/**
 * Breakpoints and media queries
 * Following this article #3
 * https://www.freecodecamp.org/news/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862/
 *
 * usage:
 * const StyledComponent = styled(Element)`
     [...]
     ${MQ_FOR_TABLET_PORTRAIT_UP} {
       [...]
     }
   `;
 */

var QUERY_FOR_PHONE_ONLY = "(max-width: 599px) and (orientation: portrait), (max-width: 900px) and (orientation: landscape)";
var MQ_FOR_PHONE_ONLY = "@media ".concat(QUERY_FOR_PHONE_ONLY);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var light = 300;
var regular = 400;
var mediumBold = 500;
var semiBold = 600;
var bold = 700;
var extraBold = 800; // This is our primary font and fallback.

var primaryFont = "\"Graphik Web\", sans-serif";
var primaryFontM = "\"ProximaNova Web\", Arial, sans-serif";
var headingFontM = "\"GeorgiaPro Web\", Georgia, serif";
var Heading = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
Heading.displayName = 'Heading';
var PageHeader = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: black;\n  font-family: ", ";\n  font-size: 32px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n\n  ", " {\n    font-size: 24px;\n    line-height: 24px;\n  }\n"])), primaryFont, semiBold, MQ_FOR_PHONE_ONLY);
PageHeader.displayName = 'PageHeader';
var H1 = styled.h1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 50px;\n  font-weight: ", ";\n  line-height: 56px;\n  margin: 0;\n"])), primaryFont, bold);
H1.displayName = 'H1';
var H1M = styled.h1(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 27px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), grayDarkM, headingFontM, semiBold);
H1M.displayName = 'H1M';
var H2 = styled.h2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 30px;\n  font-weight: ", ";\n  line-height: 40px;\n  margin: 0;\n"])), primaryFont, regular);
H2.displayName = 'H2';
var H3 = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H3.displayName = 'H3';
var H4 = styled.h4(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H4.displayName = 'H4';
var H5 = styled.h5(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, semiBold);
H5.displayName = 'H5';
var H6 = styled.h6(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 20px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, semiBold);
H6.displayName = 'H6';
var H7 = styled.h6(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 24px;\n  margin: 0;\n"])), primaryFont, regular);
H7.displayName = 'H7';
var H8 = styled.h6(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, regular);
H8.displayName = 'H8';
var H9 = styled.h6(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 24px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, mediumBold);
H9.displayName = 'H9';
var H10 = styled.h6(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  line-height: 12px;\n  margin: 0;\n"])), primaryFont, regular);
H9.displayName = 'H9';
var Text = styled.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), primaryFont, regular);
var TextM = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), grayDarkM, primaryFontM, regular);
var Link = styled.a(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), blue, primaryFont, mediumBold);
var LinkM = styled.a(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), primaryM, primaryFontM, regular);
export { H1, H10, H1M, H2, H3, H4, H5, H6, H7, H8, H9, Heading, Link, LinkM, PageHeader, Text, TextM, bold, extraBold, headingFontM, light, mediumBold, primaryFont, primaryFontM, regular, semiBold };